export default __webpack_public_path__ + "static/media/group-189.e830c766.png";